import { emailFormatRule, phoneNumberFormatRule, requiredInputRule, } from "@erp/shared/utils/form/rules";
import { OBTAIN_BASIC_INFO, } from "./ObtainWriteTab.types";
import { formatYYMMDD } from "@erp/shared/utils/date/formatted-date";
export const obtainDefaultInfo = (projectPrefix, inhouseBidNumberPrefix) => [
    {
        label: OBTAIN_BASIC_INFO.발행일,
        type: "dateSingle",
        menu: "",
        col: "12",
        sm: "4",
        lg: "4",
        value: "",
        rules: [requiredInputRule],
    },
    {
        label: OBTAIN_BASIC_INFO.프로젝트코드,
        type: "chipSelect",
        col: "12",
        sm: "4",
        lg: "4",
        value: projectPrefix + formatYYMMDD(),
        chipMeta: { mode: "auto" },
        chipOptions: {
            placeholder: "+ 프로젝트코드 선택",
            autoGenerate: () => projectPrefix + formatYYMMDD(),
            searchFn: async () => [],
            duplicateCheckFn: undefined,
            duplicateErrorMsg: "이미 존재하는 프로젝트 코드입니다",
            searchHeaders: [
                { text: "프로젝트코드", value: "displayValue" },
                { text: "프로젝트명", value: "name" },
                { text: "업체명", value: "companyName" },
                { text: "상태", value: "status" },
            ],
        },
        rules: [requiredInputRule],
    },
    {
        label: OBTAIN_BASIC_INFO.사내견적번호,
        type: "chipSelect",
        col: "12",
        sm: "4",
        lg: "4",
        value: inhouseBidNumberPrefix + formatYYMMDD(),
        chipMeta: { mode: "auto" },
        chipOptions: {
            placeholder: "+ 견적번호 선택",
            autoGenerate: () => inhouseBidNumberPrefix + formatYYMMDD(),
            searchFn: async () => [],
            duplicateCheckFn: undefined,
            duplicateErrorMsg: "이미 존재하는 사내 견적번호입니다",
            searchHeaders: [
                { text: "사내 견적번호", value: "displayValue" },
                { text: "업체명", value: "companyName" },
                { text: "상태", value: "approvalPhase" },
            ],
        },
        rules: [requiredInputRule],
    },
    {
        label: OBTAIN_BASIC_INFO.기업별입찰번호,
        col: "12",
        sm: "4",
        lg: "4",
        value: "",
        rules: [requiredInputRule],
    },
];
export const obtainDefaultInfo2 = [
    {
        label: OBTAIN_BASIC_INFO.납기일,
        type: "dateSingle",
        menu: "",
        col: "12",
        sm: "4",
        lg: "4",
        value: "",
        rules: [requiredInputRule],
    },
    {
        label: OBTAIN_BASIC_INFO.인도조건,
        col: "12",
        sm: "4",
        lg: "4",
        value: "",
        rules: [requiredInputRule],
    },
    {
        label: OBTAIN_BASIC_INFO.프로젝트명,
        col: "12",
        sm: "4",
        lg: "4",
        value: "",
        rules: [requiredInputRule],
    },
    {
        label: OBTAIN_BASIC_INFO.프로젝트기간,
        col: "12",
        sm: "4",
        lg: "4",
        value: "",
        rules: [requiredInputRule],
    },
    {
        label: OBTAIN_BASIC_INFO.특이사항,
        col: "12",
        sm: "4",
        lg: "12",
        value: "",
    },
];
export const obtainSearchCompanyInfoInputs = [
    {
        label: OBTAIN_BASIC_INFO.업체명,
        column_name: "company_name",
        col: "12",
        sm: "4",
        lg: "6",
        value: "",
        rules: [requiredInputRule],
    },
    {
        label: OBTAIN_BASIC_INFO.담당자,
        column_name: "company_manager",
        col: "12",
        sm: "4",
        lg: "6",
        value: "",
        rules: [requiredInputRule],
    },
    {
        label: OBTAIN_BASIC_INFO.담당자이메일,
        column_name: "company_manager_email",
        col: "12",
        sm: "4",
        lg: "6",
        value: "",
        rules: [requiredInputRule, emailFormatRule],
    },
    {
        label: OBTAIN_BASIC_INFO.담당자연락처,
        column_name: "company_manager_phone",
        col: "12",
        sm: "4",
        lg: "6",
        value: "",
        rules: [requiredInputRule, phoneNumberFormatRule],
    },
];
export const obtainFilesInputs = [
    {
        label: OBTAIN_BASIC_INFO.승인서,
        column_name: "approval",
        type: "file",
        col: "12",
        sm: "6",
        lg: "6",
        icon: "",
        appendIcon: "mdi-paperclip",
        smallChips: true,
        accept: ".pdf",
        value: null,
    },
    {
        label: OBTAIN_BASIC_INFO.도면,
        column_name: "blueprint",
        type: "file",
        col: "12",
        sm: "6",
        lg: "6",
        icon: "",
        appendIcon: "mdi-paperclip",
        smallChips: true,
        accept: ".pdf",
        value: null,
    },
    {
        label: OBTAIN_BASIC_INFO.수주서,
        column_name: "obtain",
        type: "file",
        col: "12",
        sm: "6",
        lg: "6",
        icon: "",
        appendIcon: "mdi-paperclip",
        smallChips: true,
        accept: ".pdf",
        value: null,
    },
    {
        label: OBTAIN_BASIC_INFO.기타,
        column_name: "files",
        type: "file",
        col: "12",
        sm: "6",
        lg: "6",
        icon: "",
        appendIcon: "mdi-paperclip",
        smallChips: true,
        multiple: true,
        value: null,
    },
];
